import React from 'react'
import { FormControl, TextField, Grid, Box,Button, MenuItem } from '@mui/material';

import { CashSection } from './CashSection';
import { DepositSection } from './DepositSection';

export const TransactionsForm = ({ useFetchInit, dataModal }) => {

    const {
        globalStates,
        Forms,
        Actions
    } = useFetchInit

    const { modalOpeningMode } = globalStates
    
    const { FormExpenseTransaction } = Forms
    const { formState, onInputChange } = FormExpenseTransaction

    const {
        onSubmitExpenseTransaction,
        handleClickHideTransactionForm,
        handleChangeTypeTransaction,
        handleChangeExpenseAmount,
        handleChangeExpenseTypeCurrency,
        handleChangeExpenseExchangeRate,
    } = Actions

    const { dataRequest } = dataModal
        
    return (
        <div className='container'>
            <div className="pt-4"></div>
            <form onSubmit={(e) => onSubmitExpenseTransaction(e, dataRequest.idexpense, dataRequest.idcontrato )}>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="movimiento_fecha">* Fecha</label>
                            <TextField
                                id="movimiento_fecha"
                                name="movimiento_fecha"
                                value={formState.movimiento_fecha}
                                onChange={onInputChange}
                                // label='Fecha'
                                size='small'
                                type="date"
                                variant={(modalOpeningMode === 'READONLY' || formState.movimiento_tipo === 'EFECTIVO') ? 'filled' : 'outlined' }
                                hiddenLabel
                                InputProps={{
                                    readOnly: (modalOpeningMode === 'READONLY' || formState.movimiento_tipo === 'EFECTIVO') ? true : false 
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="movimiento_tipo">* Tipo</label>
                            <TextField
                                id="movimiento_tipo"
                                name="movimiento_tipo"
                                // label="Tipo de movimiento"
                                value={formState.movimiento_tipo}
                                onChange={handleChangeTypeTransaction}
                                select
                                size="small"
                                variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                                // lable="Selecciona una opción"
                                hiddenLabel
                                InputProps={{ 
                                    readOnly: (modalOpeningMode === 'READONLY') ? true : false 
                                }}
                            >
                                <MenuItem value=''>-- Selecciona una opción --</MenuItem>
                                <MenuItem value='DEPOSITO'>DEPOSITO</MenuItem>
                                <MenuItem value='EFECTIVO'>EFECTIVO</MenuItem>
                            </TextField>
                        </FormControl>
                    </Grid>
                </Grid>
                <div className="pt-2"></div>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="movimiento_monto">* Monto</label>
                            <TextField
                                id="movimiento_monto"
                                name="movimiento_monto"
                                value={formState.movimiento_monto_mask}
                                onChange={handleChangeExpenseAmount}
                                size='small'
                                type="text"
                                variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                                hiddenLabel
                                InputProps={{ 
                                    readOnly: (modalOpeningMode === 'READONLY') ? true : false 
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="movimiento_moneda">* Moneda</label>
                            <TextField
                                id="movimiento_moneda"
                                name="movimiento_moneda"
                                value={formState.movimiento_moneda}
                                onChange={handleChangeExpenseTypeCurrency}
                                select
                                size="small"
                                variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                                hiddenLabel
                                InputProps={{ 
                                    readOnly: (modalOpeningMode === 'READONLY') ? true : false 
                                }}
                            >
                                <MenuItem value=''>-- Selecciona una opción --</MenuItem>
                                <MenuItem value='QUETZAL'>QUETZAL</MenuItem>
                                <MenuItem value='DOLAR'>DOLAR</MenuItem>
                            </TextField>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="movimiento_tipo_cambio">* Tipo de Cambio</label>
                            <TextField
                                id="movimiento_tipo_cambio"
                                name="movimiento_tipo_cambio"
                                value={formState.movimiento_tipo_cambio}
                                onChange={handleChangeExpenseExchangeRate}
                                // label='Tipo de cambio'
                                size='small'
                                type="number"
                                min="0"
                                step="0.01"
                                variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                                hiddenLabel
                                InputProps={{ 
                                    readOnly: (modalOpeningMode === 'READONLY') ? true : false 
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <div className="pt-2"></div>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="movimiento_quetzales">* Total en Quetzales</label>
                            <TextField
                                id="movimiento_quetzales"
                                name="movimiento_quetzales"
                                value={formState.movimiento_quetzales}
                                onChange={onInputChange}
                                // label='Total en quetzales'
                                size='small'
                                type="number"
                                min="0"
                                step="0.01"
                                variant='filled'
                                hiddenLabel
                                InputProps={{ 
                                    readOnly: true
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="movimiento_dolares">* Total en Dolares</label>
                            <TextField
                                id="movimiento_dolares"
                                name="movimiento_dolares"
                                value={formState.movimiento_dolares}
                                onChange={onInputChange}
                                // label='Total en dolares'
                                size='small'
                                type="number"
                                min="0"
                                step="0.01"
                                variant='filled'
                                hiddenLabel
                                InputProps={{ 
                                    readOnly: true
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <div className="pt-2"></div>
                {(formState.movimiento_tipo === 'EFECTIVO') && (
                    <>
                        <CashSection useFetchInit={useFetchInit} dataModal={dataModal}/>
                    </>
                )}
                {(formState.movimiento_tipo === 'DEPOSITO') && (
                    <>
                        <DepositSection useFetchInit={useFetchInit} dataModal={dataModal}/>
                    </>
                )}
                <div className="pt-2"></div>

                <div className="pt-4"></div>
                
                <Box pt={4}>
                    <Grid container spacing={2} justifyContent="flex-start">
                        <Grid item>
                            {(modalOpeningMode === 'EDITABLE') && (
                                <Button
                                    style={{background: "#4b4b4c"}}
                                    variant="contained"
                                    type="submit"
                                >
                                    <i className="fa-regular fa-floppy-disk"></i> &nbsp; Guardar
                                </Button>
                            )}
                            &nbsp; &nbsp;
                            <Button
                                style={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                                variant="contained"
                                type="button"
                                onClick={handleClickHideTransactionForm}
                            >
                                <i className="fa-regular fa-circle-left"></i> &nbsp; Cancelar
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </form>
            <div className="pt-4"></div>
        </div>
    )
    
}
